// extracted by mini-css-extract-plugin
export default {"editorContainer":"RichTextEditor_editorContainer__q9ewH","toolbar":"RichTextEditor_toolbar__ZBN-e","dark":"RichTextEditor_dark__pmv4O"};